<template>
  <div class="galerie-grid container">
    <silentbox-group class="row">
      <silentbox-item  v-for="(img, index) in gallery" :key="index" :src="img.sizes.large" class="col-12 col-md-6 col-lg-4 mb-4" :description="img.title">
        <div class="img-container">
          <img :src="img.sizes.pomzed_thumb_630" >
          <div class="overlay">
            <div class="icon">
              <svg width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><g><path d="M199.995,0c-110.279,0 -199.995,89.72 -199.995,200c0,110.279 89.716,200 199.995,200c110.282,0 200.005,-89.721 200.005,-200c0,-110.28 -89.723,-200 -200.005,-200Zm0,373.77c-95.813,0 -173.765,-77.954 -173.765,-173.77c0,-95.817 77.951,-173.77 173.765,-173.77c95.817,0 173.772,77.953 173.772,173.77c0.002,95.816 -77.955,173.77 -173.772,173.77Z" style="fill-rule:nonzero;"/><path d="M279.478,186.884l-66.363,0l0,-66.364c0,-7.243 -5.872,-13.115 -13.115,-13.115c-7.243,0 -13.115,5.873 -13.115,13.115l0,66.368l-66.361,0c-7.242,0 -13.115,5.873 -13.115,13.115c0,7.243 5.873,13.115 13.115,13.115l66.358,0l0,66.362c0,7.242 5.872,13.114 13.115,13.114c7.242,0 13.115,-5.872 13.115,-13.114l0,-66.365l66.367,0c7.241,0 13.114,-5.873 13.114,-13.115c0,-7.243 -5.873,-13.116 -13.115,-13.116Z" style="fill-rule:nonzero;"/></g></svg>
            </div>
           </div>
        </div>
      </silentbox-item>
    </silentbox-group>
  </div>
</template>
<script>
import api from '@/api'
export default {
  data () {
    return {
      gallery: []
    }
  },
  methods: {
    /**
     * Get galery image
     * @request HTTP | GET
     */
    fetchGalerie () {
      this.axios.get(api.galerie_page)
        .then(response => {
          this.gallery = response.data[0].acf.page_gallery
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted () {
    this.fetchGalerie()
  }
}
</script>
<style lang="sass" scoped>
  @import 'GalerieGrid';
</style>



// WEBPACK FOOTER //
// src/components/Galery/GalerieGrid.vue